import React from "react";
import images from "../../../images";
import { useTranslation } from "react-i18next";

const HeaderReferral = ({
  menuIcon,
  onMenuClick,
  isDropDownOpen,
  onDropDownBackClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center w-full bg-white">
      <div className="w-full relative">
        <div className="w-full h-[75px] bg-[#ECEEFF]"></div>
        {menuIcon ? (
          <>
            {isDropDownOpen && (
              <div
                className="fixed inset-0 bg-white opacity-0 z-40"
                onClick={() =>
                  typeof onMenuClick === "function" && onMenuClick()
                }
              />
            )}
            <div
              onClick={() => typeof onMenuClick === "function" && onMenuClick()}
              className="absolute top-[39px] right-6 cursor-pointer z-50"
            >
              <img
                loading="lazy"
                src={menuIcon}
                alt="Menu"
                className="object-contain self-stretch my-auto w-6 h-6 rounded-md aspect-square"
              />
              {isDropDownOpen && (
                <div
                  className="flex flex-col absolute right-[2px] top-[36px] z-50 px-3 py-6 justify-center items-start w-full min-w-[120px] bg-white rounded-[10px] border-[#EEEAE8] border-solid border-[1px]"
                  style={{
                    boxShadow: "0 3px 6px 0 rgba(72, 72, 72, 0.5)",
                  }}
                >
                  <div
                    onClick={() =>
                      typeof onDropDownBackClick === "function" &&
                      onDropDownBackClick()
                    }
                    className="w-full cursor-pointer rounded-t-[10px]"
                  >
                    <div className="flex flex-row justify-start items-center py-[18px] gap-1.5">
                      <img
                        src={images.ArrowLeftIconBlue}
                        alt=""
                        className="w-6 h-6"
                      />
                      <span className="text-lg font-medium text-[#253FF6]">
                        {t("base.back") || "Back"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : null}
        
        <div className="flex absolute top-[30px] left-[30px] flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20">
          <div className="w-[70px] h-[70px] rounded-[6px] bg-[#8DC63F] flex items-center justify-center border border-[#E9E6E4]">
            <span className="text-white text-4xl">🌿</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderReferral;

